import { render, staticRenderFns } from "./SplitOrderOnline.vue?vue&type=template&id=5a33501e&scoped=true"
import script from "./SplitOrderOnline.vue?vue&type=script&lang=js"
export * from "./SplitOrderOnline.vue?vue&type=script&lang=js"
import style0 from "./SplitOrderOnline.vue?vue&type=style&index=0&id=5a33501e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a33501e",
  null
  
)

export default component.exports